import { render } from "./examHelpPage.vue?vue&type=template&id=038102f4&scoped=true"
import script from "./examHelpPage.vue?vue&type=script&lang=js"
export * from "./examHelpPage.vue?vue&type=script&lang=js"

import "./examHelpPage.vue?vue&type=style&index=0&id=038102f4&scoped=true&lang=scss"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038102f4"]])

export default __exports__